export const FLEET_LANDMARK_CREATE_UPDATE_LANDMARK = "FLEET_LANDMARK_CREATE_UPDATE_LANDMARK";
export const FLEET_LANDMARK_CREATE_UPDATE_LANDMARK_RESULT = "FLEET_LANDMARK_CREATE_UPDATE_LANDMARK_RESULT";
export const FLEET_LANDMARK_OPEN_MODAL = "FLEET_LANDMARK_OPEN_MODAL";